query componentPrice($slug: String!) {
  price: componentPrice(slug: $slug) {
    id
    price
    currency
  }
}
